export const Accordion = {
    boxShadow: 'none'
}

export const Title = {
    fontWeight: 'bold'
}